import api from "@/api/axios";

const usuarioModel = {
    data: {
        name: null,
        email: null,
        password: null,
        password_confirmation: null,
        acepta_terminos: null,
        acepta_ddjj: null,

        perfil: {
            id: null,
            name: null,
            email: null,
            razon_social: null,
            cuit: null,
            direccion: null,
            provincia_id: null,
            ciudad: null,
            referencia_id: null,
            celular: null,
        }
    },

    async iniciarSesion(email, password, returnUrl) {
        try {
            const response = await api.post("/login", { email, password , returnUrl});
            return response.data;
        } catch (error) {
            console.error("Error en el inicio de usuario", error);
            throw error;
        }
    },

    async getSession() {
        try {
            const response = await api.get(`/get-session`, { skipGlobalLoading: true });
            return response.data;
        } catch (error) {
            console.error("Error en obtener el usuario", error);
            throw error;
        }
    },

    async registrarUsuario(
        name,
        email, 
        password, 
        password_confirmation, 
        acepta_ddjj, 
        acepta_terminos, 
        referencia_id,
        returnUrl ) {
        try {
            const response = await api.post("/register/", { name, email, password, password_confirmation, acepta_ddjj, acepta_terminos, referencia_id, returnUrl})
            return response.data;
        } catch (error) {
            console.error("Error en registrar usuario", error);
            throw error;
        }
    },

    async cerrarSesion() {
        try {
            await api.post(`/logout`);
        } catch (error) {
            console.error("Error al cerrar sesion de usuario", error);
            throw error;
        }
    },

    async confirmarLoginExterno({ token, session_id, id }) {
        try {
            const response = await api.post("/external-confirm-login", {
                token,
                session_id,
                id
            });
            return response.data;
        } catch (error) {
            console.error("Error al confirmar login externo", error);
            throw error;
        }
    },

    async obtenerPerfilesFacturacionUsuario(){
        try {
            return await api.get(`/usuarios/perfiles-facturacion`);
        } catch (error) {
            console.error("Error al obtener datos de Facturacion", error);
            throw error;
        }
    },

    async crearPerfilFacturacion(payload = {}) {
        try {
            const response = await api.post('/usuarios/perfiles-facturacion', payload);
            return response.data;
        } catch (error) {
            console.error('Error al crear perfil de facturación', error);
            throw error;
        }
    },

    async editarPerfilFacturacion(id, payload = {}) {
        try {
            const response = await api.put(`/usuarios/perfiles-facturacion/${id}`, payload);
            return response.data;
        } catch (error) {
            console.error('Error al editar perfil de facturación', error);
            throw error;
        }
    },

    async eliminarPerfilFacturacion(id) {
        try {
            const response = await api.delete(`/usuarios/perfiles-facturacion/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error al eliminar perfil de facturación', error);
            throw error;
        }
    },

    async updateProfile(payload = {}) {
        try {
            const response = await api.put(`/usuarios/perfil`, payload);
            return response.data;
        } catch (error) {
            console.error("Error al actualizar el perfil", error);
            throw error;
        }
    },

    async uploadProfilePhoto({ archivo, extension } = {}) {
        try {
            const payload = {
                foto_perfil: {
                    archivo,
                    extension,
                },
                // compat: algunos backends aceptan plano
                archivo,
                extension,
            };
            const response = await api.post(`/usuarios/perfil/foto`, payload);
            return response.data;
        } catch (error) {
            console.error("Error al subir la foto de perfil", error);
            throw error;
        }
    },

    async confirmarRegistro(pendingId, token) {
        return await api.post(`/register/confirm`, {
            pending_id: pendingId,
            token: token,
        }); 
    },
    
    async changePassword({ password, new_password, new_password_confirmation } = {}) {
        try {
            const response = await api.post('/change-password', {
                password,
                new_password,
                new_password_confirmation,
            });
            return response.data;
        } catch (error) {
            console.error('Error al cambiar la contraseña', error);
            throw error;
        }
    },

    async obtenerReferencias() {
        try {
            const response = await api.get(`/referencias`);
            return response.data;
        } catch (error) {
            console.error("Error al obtener referencias", error);
            throw error;
        }
    },  

    async obtenerHistorialOfertas() {
         try {
            const response = await api.get("/pujas/mis-ofertas");
            return response.data;
        } catch (error) {
            console.error("Error al obtener historial de ofertas", error);
            throw error;
        }
    }
};

export default usuarioModel;